import styled from 'styled-components';
import icon_home from './icon_home.svg';
import { SsqImages } from 'images/SsqImages';

export const TitleBarContainer = styled.div`
  width: 100%;
  //background: #3A3E49;
  background-color: #eef1f6;
`;

export const TitleBarContents = styled.div`
  padding: 0 1.6rem;
  height: 3.2rem;
  //background: #3A3E49;
  font-size: 1.2rem;
  overflow: hidden;
  display: flex;
  > div:first-child {
    background: url(${icon_home}) no-repeat left center;
    padding-left: 2rem;
  }
`;

export const TitleBarItem = styled.div`
  //color: white;
  color: #2a2c2f;
  padding-left: 0.6rem;
  position: relative;
  height: 3.2rem;
  line-height: 3.4rem;
  display: inline-flex;
  align-items: center;
  //min-width: 112px;
  padding-right: 0rem;

  & a {
    color: #2a2c2f;
  }

  /* a {
    text-decoration: none;
    color: white;
    display: block;
    width: 100%;
  } */

  &:first-child {
    padding-left: 0;
  }

  &:not(.selected) {
    &:after {
      content: '>';
      //position: absolute;
      padding-left: 0.5rem;
      /* width: 12px;
      height: 32px; */
      /* top: 0;
      right: 0;
      z-index: 3; */
      //background-image: url(${SsqImages.header.titlebarbg()});
    }
  }

  &.selected {
    //background-color: #3875D2;
    background-image: none;
    position: relative;
    margin-left: -12px;
    padding: 0 16px 0 20px;

    /* &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: 0;
      right: -9px;
      border-top: 16px solid transparent;
      border-left: 10px solid #3875D2;
      border-bottom: 16px solid transparent;
    } */
  }

  @media screen and (max-width: 400px) {
    flex-shrink: 2;
    min-width: auto;
    width: max-content;
    padding-right: 3rem;

    &.selected {
      flex-shrink: 1;
      flex-grow: 2;
      max-width: max-content;
    }
  }
`;
